<template>
  <div id="packageList">
        <div v-if="packagesReady == true">
            <h3>{{ strings.chooseapackage }}</h3>
                <p class="small" v-if="lang!=='de'&& (!noHalfDayPackage && !noFullDayPackage && !noOvernightPackage && !noTwoDaysPackage) || (isOpera && !noPackage)" >
                    {{ strings.showing }} <strong>{{ availablePackages }} {{ strings.outof }} {{ numPackage }}</strong> {{ strings.packages }} {{ strings.suitablecriteria }}.
             </p>
        </div>
        <MPDiscountCodeBlock v-if="!isBE" />
        <!-- Customized radio buttons -->
      <p class="loading-indicator" v-show="packagesReady == false && isBE && !isMoreThanOneDay">
          <pulse-loader :color="'#9d9d9d'"></pulse-loader>
      </p>
        <form class="radio" >
            <MPPackageItem 
                :id="item.id" 
                v-for="(item, key) in availablePackagesList()" 
                :key="key"
                v-show="key < x"
                :title="!item.title[lang] ? item.title.en : item.title[lang]"
                :type="item.package_length"
                :min="item.package_min"
                :max="item.package_max"
                :description="item.description"
                :packageIncludes="item.services"
                :allIncludes="item.all_services"
                :rooms="item.rooms"
                :calculatedPrices="item.calculated_prices"
                :correctPrice="item.correct_price"
                :exceed="item.exceed"
                :available="item.is_smart_space == true ? true: item.available"
                :demand="item.demand ? item.demand: ''"
                :isSmartSpace="item.is_smart_space == true"
                :allRoomExceed="item.allRoomExceed"
                :allRoomUnavailable="item.allRoomUnavailable"
                :selected_package="selected_package"
                :day="day"
                :position="key"
                :contentInclude="item.content"
                :isNew="item.is_new"
                v-if="(isRightPackage(item.package_length) || item.is_smart_space == true) && !isOpera"
            />

            <OperaPackageItem 
                :id="item.id" 
                v-for="(item, key) in availablePackagesList()" 
                :key="key"
                v-show="key < x"
                :title="!item.title[lang] ? item.title.en : item.title[lang]"
                :type="item.package_length"
                :min="item.package_min"
                :max="item.package_max"
                :description="item.description"
                :roomDescription="item.room_description"
                :packageIncludes="item.services"
                :allIncludes="item.all_services"
                :rooms="item.rooms"
                :calculatedPrices="item.calculated_prices"
                :correctPrice="item.correct_price"
                :exceed="item.exceed"
                :available="item.is_smart_space == true ? true: item.available"
                :demand="item.demand ? item.demand: ''"
                :isSmartSpace="item.is_smart_space == true"
                :allRoomExceed="item.allRoomExceed"
                :allRoomUnavailable="item.allRoomUnavailable"
                :selected_package="selected_package"
                :day="day"

                :instantBookable="item.instant_bookable"
                :image="item.room_pictures"
                :valid_layout="item.valid_layout"
                :eventsInclude="item.events"

                :roomHeight="item.height"
                :roomWidth="item.width"
                :roomLength="item.length"
                :roomArea="item.area"

                :roomEquipment="item.equipment_name"
                :roomEquipmentFee="item.equipment_fee_name"
                :roomAllEquipment="item.all_equipment"

                :packageStart="item.package_start"
                :packageEnd="item.package_end"
                
                v-if="isOpera"
            />

        </form>

        <div v-if="(noHalfDayPackage || noFullDayPackage || noOvernightPackage || noTwoDaysPackage) && !noPackage && !isOpera" class="temp mb-15 radio__no-avail">
            <label for="radio6">
                <div class="radio__main">
                    <div class="radio__head">
                        <h3>{{ strings.notavailable }}</h3>
                         <p>{{ strings.ohsnapnopackage }}...</p>
                        <ul class="checklist">
                            <li class="checklist__item checklist__item--stack checklist__item--attention" v-if="noHalfDayPackage">{{ strings.thereisno }} {{ strings.halfdaypackage }} {{ strings.inthisvenue }}.</li>
                            <li class="checklist__item checklist__item--stack checklist__item--attention" v-if="noFullDayPackage">{{ strings.thereisno }} {{ strings.fulldaypackage }} {{ strings.inthisvenue }}.</li>
                            <li class="checklist__item checklist__item--stack checklist__item--attention" v-if="noOvernightPackage">{{ strings.thereisno }} {{ strings.overnightpackage }} {{ strings.inthisvenue }}.</li>
                            <li class="checklist__item checklist__item--stack checklist__item--attention" v-if="noTwoDaysPackage">{{ strings.thereisno }} {{ strings.twodayspackage }} {{ strings.inthisvenue }}.</li>
                        </ul>
                    </div>
                </div>
            </label>
        </div>
        <div v-if="noPackage && !isOpera" class="temp mb-15 radio__no-avail">
            <label for="radio6">
                <div class="radio__main">
                    <div class="">
                        <h3>{{ strings.notavailable }}</h3>
                         <p>{{ strings.noPackage }}.</p>
                    </div>
                </div>
            </label>
        </div>
        <div v-if="noPackage && isOpera" class="temp mb-15 radio__no-avail">
            <label for="radio6">
                <div class="radio__main">
                    <div class="">
                        <h3>{{ strings.notavailable }}</h3>
                         <p>{{ strings.noOperaPackage }}.</p>
                    </div>
                </div>
            </label>
        </div>
        <a href="" class="button full-on-mobile"  v-if="showMoreStatusPackage" @click.prevent="showMore()" >{{ strings.showmore }} {{ strings.packages }} ({{packageLeft}})</a>
        <a href="" v-scroll-to="'#packageList'" class="button full-on-mobile" @click.prevent="showLess()" v-if="showFewerStatusPackage">{{ strings.showfewer }} {{ strings.packages }}</a>
    </div>
</template>

<script>
import OperaPackageItem from './OperaPackageItem_New';
import MPPackageItem from './PackageItem';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import MPDiscountCodeBlock from './DiscountCodeBlock'
import * as dataLayer from '../assets/misc/dataLayer.js';

export default {
    data () {
        return {
            numPackage: 0,
            noHalfDayPackage: '',
            noFullDayPackage: '',
            noOvernightPackage: '',
            noTwoDaysPackage: '',
            noPackage: '',
            x: 5,
            step: 5,
            packageLeft: '',
            availablePackages: 0        
            }
    },
    props: [
        'packages',
        'selected_package',
        'day'
    ],
    components: {
        MPPackageItem,
        OperaPackageItem,
        PulseLoader,
        MPDiscountCodeBlock
    },
    watch: {
        packagesReady(value, oldvalue){
            if(oldvalue == false){
                let availablePackagesList = this.availablePackagesList();
                let max = this.packageLeft == '' || this.packageLeft < 0 ? this.x: availablePackagesList.length - this.packageLeft;
            }
        },
        packageInfo(value){
            let self = this;
            let availablePackagesList = value.filter(function(element){
                    return self.isRightPackage(element.package_length) || self.isOpera;
            });
            if(this.packagesReady){
                let max = this.packageLeft == '' || this.packageLeft < 0 ? this.x: availablePackagesList.length - this.packageLeft;
            }
        },

        shouldHide(value) {
            if(value == true){
                if(this.$store.state.isOpera){
                    /*this.$store.dispatch('getRoomOpera', {
                        'id' : this.$store.state.venueInfo.id,
                        'hotelID' : this.$store.state.venueInfo.operaHotelID,
                        'hotelChainCode' : this.$store.state.venueInfo.operaChainCode,
                        'hotelServer' : this.$store.state.venueInfo.operaServer
                    });*/
                } else {
                    this.$store.commit('setCurrentTab', 'room');
                    this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
                }         
            }
        }       
    },
    computed: {
        lang() {
            return this.$store.state.selectedLang;
        },
        isMoreThanOneDay() {
            return this.$store.state.isMoreThanOneDay;
        },
        packagesReady(){
            return this.$store.state.packagesReady;
        },
        isOpera() {
            return this.$store.state.isOpera;
        },
        isBE() {
            return this.$store.state.isBE;
        },
        packageInfo() {
            var _packages = [];
            var self = this;
            if(this.isMoreThanOneDay){
                _packages = this.packages;
            } else {
                _packages = this.$store.state.packageInfo;
            }
            let packagesLoaded = this.$store.state.packagesLoaded;
            if(packagesLoaded){
                let hasNewPackages = false;
                let packageList = _packages;
                let mt_length = parseInt(this.$store.state.meeting_length);
                let route = this.$route;
                let pk = '';
                if(mt_length >= 2 && mt_length <= 5){
                    pk = '4'
                } else if(mt_length >= 6 && mt_length <= 10 ) {
                    pk = '8'
                } else if(this.$store.state.meeting_length == 'overnight'){
                    pk = '24'
                } else if(this.$store.state.meeting_length == 'twodays'){
                    pk = '36'
                }
                let count = 0;
                let numPackage = 0;
                if(packageList && packageList.length > 0){
                    let count_4 = 0;
                    let count_8 = 0;
                    let count_24 = 0;
                    let count_36 = 0;
                    packageList.forEach(el => {
                        if(el.is_new){
                            hasNewPackages = true;
                        }
                        switch (el.package_length) {
                            case '4':
                            count_4++;
                            break;
                            case '8':
                            count_8++;
                            break;
                            case '24':
                            count_24++;
                            break;
                            case '36':
                            count_36++;
                            break;
                        }
                        
                    });

                    let allPackages = packageList;
                    allPackages.forEach(element => {
                        if(element.package_length == pk || this.isOpera || element.is_new){
                            numPackage++;
                            if( (element.available && element.exceed == 'no' && element.allRoomUnavailable == 'no') || element.is_smart_space == true){
                                count++;
                            }
                        }
                    });

                    let minRoomNum = this.$store.state.minRoomNuminPackage;
                    if(minRoomNum == ''){
                        minRoomNum = 10;
                    }
                    if(!this.$cookie.get('_pref_qty') && count == 0 && !route.query.delegates && !window.wl_default_delegates){
                        this.$store.commit('setDelegates', minRoomNum);
                        this.$cookie.set('_pref_qty', minRoomNum);
                        
                        this.$store.dispatch('sortPackageList');
                        if(this.checkAvailable() > 0){
                            this.$store.commit('setPackageFormDisabled', 'no');
                        } else {
                            this.$store.commit('setPackageFormDisabled', 'yes');
                        }      
                    } else if(!this.$cookie.get('_pref_qty') && count != 0 && !route.query.delegates){
                        this.$store.commit('setPackageFormDisabled', 'no');
                    } else {
                        if(count == 0){
                            this.$store.commit('setPackageFormDisabled', 'yes');
                        } else {
                            
                            this.$store.commit('setPackageFormDisabled', 'no');
                        }
                    }

                    if (count_4 == 0 && pk == '4' && !hasNewPackages) {
                        this.noHalfDayPackage = true;
                    } else {
                        this.noHalfDayPackage = false;
                    }
                    if (count_8 == 0 && pk == '8' && !hasNewPackages) {
                        this.noFullDayPackage = true;
                    } else {
                        this.noFullDayPackage = false;
                    }
                    if (count_24 == 0 && pk == '24' && !hasNewPackages) {
                        this.noOvernightPackage = true;
                    } else {
                        this.noOvernightPackage = false;
                    }
                    if (count_36 == 0 && pk == '36' && !hasNewPackages) {
                        this.noTwoDaysPackage = true;
                    } else {
                        this.noTwoDaysPackage = false;
                    }
                    if(packageList.length == 0 || count == 0){
                        this.noPackage = true;
                    } else {
                        this.noPackage = false;
                    }
                    this.numPackage = numPackage;
                    this.availablePackages = count;

                    let discount_code = this.$cookie.get('discount_code');
                    let disc_price_count = 0;
            
                    packageList.forEach(element => {
                        if((element.package_length == pk) || self.isOpera || hasNewPackages){
                            if(element.calculated_prices.type == 'disc_price'){
                                disc_price_count++;
                            }
                        }
                    });

                    if(disc_price_count > 0 || !discount_code){
                        this.$store.commit('showDiscPriceError', false);
                    } else if(discount_code && disc_price_count == 0) {
                        setTimeout(() => {
                            this.$cookie.set('discount_code', '');
                            this.$store.commit('showDiscPriceError', true);
                        }, 100);
                    }
                    
                } else {
                    this.$store.commit('setPackageFormDisabled', 'yes');
                    this.noPackage = true;
                }
            }
            return _packages;
            
            
        },
        shouldHide() {
            return this.$store.state.isPackageFormDisabled;
        },
        strings () {
  	        return this.$store.state.strings
        },
        packagesReady() {
            return this.$store.state.packagesReady;
        },
        showFewerStatusPackage() {
            let packageLength =  this.availablePackagesList().length;
            this.packageLeft = packageLength - this.x;
            if(this.x == packageLength && packageLength != 5){
                return true;
            } else {
                return false;
            }
        },
        showMoreStatusPackage() {
            let packageLength =  this.availablePackagesList().length;
            if(this.x >= packageLength){
                return false;
            } else {
                return true;
            }
        }
    },
    methods: {
        isRightPackage(packageLength){
            if(!packageLength){
                return true;
            }
            let mt_length = parseInt(this.$store.state.meeting_length);
            let pk = '';
            if(mt_length >= 2 && mt_length <= 5){
                pk = '4'
            } else if(mt_length >= 6 && mt_length <= 10 ) {
                pk = '8'
            } else if(this.$store.state.meeting_length == 'overnight'){
                pk = '24'
            } else if(this.$store.state.meeting_length == 'twodays'){
                pk = '36'
            }
            if(packageLength == pk){
                return true;
            } else {
                return false;
            }
        },
         availablePackagesList(){
            let i = 0;
            let mt_length = parseInt(this.$store.state.meeting_length);
            let packages = this.packageInfo;
            let self = this;
            let availablePackagesList = '';
            if(packages){
                availablePackagesList = packages.filter(function(element){
                    return self.isRightPackage(element.package_length) || self.isOpera;
                });

                let pk = '';
                if(mt_length >= 2 && mt_length <= 5){
                    pk = '4'
                } else if(mt_length >= 6 && mt_length <= 10 ) {
                    pk = '8'
                } else if(this.$store.state.meeting_length == 'overnight'){
                    pk = '24'
                } else if(this.$store.state.meeting_length == 'twodays'){
                    pk = '36'
                }

            }
            return availablePackagesList;
        },
        checkAvailable(){
            let mt_length = parseInt(this.$store.state.meeting_length);
            let allPackages = this.$store.state.packageInfo;
            let pk = '';
            if(mt_length >= 2 && mt_length <= 5){
                pk = '4'
            } else if(mt_length >= 6 && mt_length <= 10 ) {
                pk = '8'
            } else if(this.$store.state.meeting_length == 'overnight'){
                pk = '24'
            } else if(this.$store.state.meeting_length == 'twodays'){
                pk = '36'
            }
            let count = 0;
            if(allPackages){
                allPackages.forEach(element => {
                    if(element.package_length == pk){
                        if(element.available && element.exceed == 'no' && element.allRoomUnavailable == 'no'){
                            count++;
                        }
                    }
                });
            }
            return count;
        },
        showMore() {
            let packageLength = this.availablePackagesList().length;
            this.x = this.x + this.step <= packageLength ? this.x + this.step : packageLength;
            this.packageLeft = packageLength - this.x;
            let packageList = this.availablePackagesList();
        },
        showLess() {
            let packageLength = this.availablePackagesList().length;
            this.x = 5;
            this.packageLeft = packageLength - this.x;
            let packageList = this.availablePackagesList();
        }
    }
}
</script>

